import Route from '@ember/routing/route';

/**
 * Landing page for the email-verification link.
 * The API's verify-email endpoint 302s here; on Android the redirect
 * normally opens the app via App Link, so this page is the fallback
 * for desktop/iOS browsers (or when the link failed).
 */
export default class VerifiedRoute extends Route {
  queryParams = {
    error: { refreshModel: true },
  };

  model(params: { error?: string }) {
    return { error: params.error };
  }
}
